angular.module('app').directive("browseServer", [
    '$compile',
    'mediaService',
    '$uibModal',
    'errorHandler',
    function ($compile, mediaService, $modal, errorHandler) {
        return {
            priority: 1001,
            restrict: "E",
            replace: true,
            templateUrl: "views/directives/browseServer.html",
            compile: function (element) {
                var previewHtml = "<div ng-show=\"!!imageToLoad\"><div style=\"height: 400px;width: 350px\"><img ng-src=\"{{imageToLoad.fileUrl}}\" > </div></div>",
                    template,
                    dragElem = $(element).parent().find(".drug-file-contain");

                template = angular.element(previewHtml);
                dragElem.after(template);

                template = $compile(template);

                return function (scope) {
                    template(scope);
                    scope.openBrowseFromServer = function () {
                        var modalInstance = $modal.open({
                            templateUrl: "views/browseServer/browseFromServerWithPagination.html",
                            controller: "BrowseFromServerWithPaginationModalController",
                            resolve: {
                                preloadedImages: function () {
                                    return mediaService.getImageList({"limit": 10, "current_page": 1}).then(
                                        function (response) {
                                            if (response.status == "ok") {
                                                return response;
                                            } else {
                                                errorHandler(response.message);
                                                return [];
                                            }
                                        }
                                    )
                                }
                            }
                        });

                        modalInstance.result.then(
                            function (result) {
                                if (result && result[0] && result[0].fileUrl) {
                                    scope.imageToLoad = result[0];
                                    if (scope.pageData) {
                                        scope.pageData.forceTOChange = true;
                                    }
                                    scope.imageDeleted = false;
                                }
                            }, function () {
                                
                            }
                        )
                    }
                }
            }
        }
    }
]).directive("browseLogos", [
    '$compile',
    'mediaService',
    '$uibModal',
    'Utils',
    function ($compile, mediaService, $modal, Utils) {
        return {
            priority: 1002,
            restrict: "E",
            replace: true,
            templateUrl: "views/directives/browseServer.html",
            scope: {
                menu: "=menu"
            },
            compile: function (element) {
                var previewHtml = "<div ng-show=\"!!imageToLoad\"><div style=\"height: 400px;width: 350px\"><img ng-src=\"{{imageToLoad.fileUrl}}\" > </div></div>",
                    template,
                    dragElem = $(element).parent().find(".drug-file-contain");

                template = angular.element(previewHtml);
                dragElem.after(template);

                template = $compile(template);

                return function (scope) {
                    template(scope);

                    scope.openBrowseFromServer = function () {
                        var modalInstance = $modal.open({
                            templateUrl: "views/browseServer/browseFromServer.html",
                            controller: "BrowseFromServerModalController",
                            resolve: {
                                preloadedImages: function () {
                                    return mediaService.getLogos().then(
                                        function (response) {
                                            if (response.status == "ok") {
                                                return angular.copy(response.items || []);
                                            } else {
                                                errorHandler(response.message);
                                                return [];
                                            }
                                        }
                                    )
                                }
                            }
                        });

                        modalInstance.result.then(
                            function (result) {
                                if (result && result[0] && result[0].fileUrl) {
                                    Utils.getBlob(result[0].fileUrl, function (blob, result) {
                                        scope.menu.uploaded_image = result
                                    });
                                }
                            },
                            function () {
                                
                            }
                        )
                    }
                }
            }
        }
    }
]).directive("browseGameImages", [
    '$compile',
    'mediaService',
    '$uibModal',
    'errorHandler',
    'logger',
    function ($compile, mediaService, $modal, errorHandler, logger) {
        return {
            priority: 1003,
            restrict: "E",
            replace: true,
            templateUrl: "views/directives/browseServer.html",
            link: function (scope, element) {
                var previewHtml = "<div ng-show=\"!!imageToLoad\"><div style=\"height: 400px;width: 350px\"><img ng-src=\"{{imageToLoad.fileUrl}}\" > </div></div>",
                    template,
                    dragElem = $(element).parent().find(".drug-file-contain");

                template = angular.element(previewHtml);
                dragElem.after(template);

                template = $compile(template);
                template(scope);
                scope.openBrowseFromServer = function () {
                    var modalInstance = $modal.open({
                        templateUrl: "views/browseGameImages/browseGameImages.html",
                        controller: "BrowseFromServerModalController",
                        resolve: {
                            preloadedImages: function () {
                                return mediaService.getGameImages({'skin_game_id': scope.game.gameSkinId}).then(
                                    function (response) {
                                        if (response.status == "ok") {
                                            return angular.copy(response.items || []);
                                        } else {
                                            errorHandler(response.message);
                                            return [];
                                        }
                                    }
                                )
                            }
                        }
                    });

                    modalInstance.result.then(
                        function (result) {
                            if (result && result[0] && result[0].fileUrl) {
                                scope.page.media.gameIdImageMap[scope.game.gameSkinId].media = result[0];
                                scope.imageDeleted = false;
                            }
                        },
                        function () {
                            
                        }
                    )
                }
            }
        }
    }
]);
